import React from 'react';

const Microsoft = (props) => {
  return (
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="24px" height="24px">
      <path d="M18 14h6c1.105 0 2-.895 2-2V6c0-1.105-.895-2-2-2h-6c-1.105 0-2 .895-2 2v6C16 13.105 16.895 14 18 14zM14 12V6c0-1.105-.895-2-2-2H6C4.895 4 4 4.895 4 6v6c0 1.105.895 2 2 2h6C13.105 14 14 13.105 14 12zM16 18v6c0 1.105.895 2 2 2h6c1.105 0 2-.895 2-2v-6c0-1.105-.895-2-2-2h-6C16.895 16 16 16.895 16 18zM12 16H6c-1.105 0-2 .895-2 2v6c0 1.105.895 2 2 2h6c1.105 0 2-.895 2-2v-6C14 16.895 13.105 16 12 16z"/>
    </svg>
  );
};
export default Microsoft;
